import React__default from 'react';
import styles from './LuminateLoader.module.scss.js';
import classNames from 'classnames';
import '@walmart-web/livingdesign-components/index.esm.css';
import { Body } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import '../IconButton/IconButton.js';
import '@livingdesign/icons';
import '@livingdesign/tokens/dist/js/light/regular/components/Form';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import '../Modal/Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../components/Popover/Popover.js';
import '../components/InfoUnderline/InfoUnderline.js';
import img from '../assets/defaultLogo.svg.js';
import '../CardActionArea/CardActionArea.js';
import '../HierarchySelector/HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import '../Table/Table.js';
import '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';
import '../OverlayHeader/OverlayHeader.js';

/**
 * The Loader component provides a visual indication of loading status. It includes:
 * - Loading Text: A customizable text label that communicates the loading status to the user. This text is passed as a prop to the component, allowing for flexibility and reuse in various contexts where different messages might be appropriate.
 * - Loader: A visual element that animates to indicate that an operation is in progress. This could be styled as a progress bar, a spinner, or any other design that conveys the concept of "loading" to the user.
 * - Image:A boolean that determines whether an image is shown alongside the loading indicator.
 *
 * Props:
 * - loadingText: Specifies the text displayed as part of the loading indicator.
 * - showImage: A boolean that determines whether an image is shown alongside the loading indicator.
 * - backgroundBlur: If backgroundBlur is true, the background will be transparent. If it's false, the background will be white.
 */

var Loader = function Loader(props) {
  var loadingText = props.loadingText,
    showImage = props.showImage,
    _props$backgroundBlur = props.backgroundBlur,
    backgroundBlur = _props$backgroundBlur === void 0 ? false : _props$backgroundBlur;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.center, backgroundBlur && styles.backgroundBlur)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.flexDir
  }, /*#__PURE__*/React__default.createElement(Body, {
    as: "div"
  }, loadingText), /*#__PURE__*/React__default.createElement("div", {
    className: styles.loader
  }), showImage && /*#__PURE__*/React__default.createElement("img", {
    className: styles.image,
    src: img,
    alt: "Scintilla Logo"
  })));
};
var LuminateLoader = function LuminateLoader(props) {
  if (process.env.NODE_ENV === 'development') {
    console.warn('LuminateLoader is deprecated. Please use Loader instead.');
  }
  return /*#__PURE__*/React__default.createElement(Loader, props);
};

export { Loader, LuminateLoader };
